<script>
    export let type = 'error';
    export let text = null;
    import {sgettext} from '../../i18n.js';

    let iconClass = '';
    let legend = '';

    getIconClass();

    function getIconClass(){
        switch(type) {
            case 'error':
                iconClass = 'fa-exclamation-circle';
                legend = `${sgettext('$$ERROR_1$$')}`;
                break;
            case 'info':
                iconClass = 'fa-info-circle';
                legend = `${sgettext('$$INFO$$')}`;
                break;
            case 'warning':
                iconClass = 'fa-exclamation-triangle';
                legend = `${sgettext('$$WARNING_1$$')}`;
                break;
            default:
                iconClass = 'fa-check';
                legend = `${sgettext('$$SUCCESS$$')}`;
                break;

        }

    }
</script>

<style>

</style>

{#if text}
<div class="alert {`alert-${type}`}">
    <i class="fas {iconClass}"></i> 
    <strong>{legend}</strong> 
    {#if Array.isArray(text)}
    {#each text as t}
    <div>{t}</div>
    {/each}
    {:else}
    <div>{text}</div>
    {/if}
</div>
{/if}